import { t } from '@trimble/i18n';
import { Component, Show } from 'solid-js';
import { DropDownMenu } from '@tcweb/connect-ui';
import { DataTypeListConfig } from './interfaces';
import { TierLock } from '@trimble/ui-components/solidjs';
import { TieringBehaviors, TieringFeatures } from '@trimble/types';

export interface DataHeaderProps {
  projectId: string;
  title?: string;
  dataTypeList: DataTypeListConfig[];
  onAddItem(projectId: string): void;
  disableAddItem?: boolean;
  tooltipAddItem?: string;
}

const DataHeader: Component<DataHeaderProps> = (props) => {
  const title = (): string =>
    props.title ?? t('shared.projectDataManager.dataHeader.title');
  const onSearch = (): void => {
    console.log('Search triggered');
  };

  const onSort = (): void => {
    console.log('Sort triggered');
  };

  const hideForQ2 = true;

  return (
    <>
      <div class="flex h-[65px] justify-between items-center py-2 pr-2 border-b border-gray-3">
        <div>
          <div class="text-[1.375rem] font-semibold pl-2">{title()}</div>
          <Show when={!hideForQ2}>
            <div class="mt-2">
              <DropDownMenu
                type="button"
                anchorText={t(
                  'shared.projectDataManager.dataHeader.dataTypeListMsg'
                )}
                anchorIcon="tc-icon-arrow-drop-down"
                anchorIconPosition="right"
                anchorClassName="secondary"
                optionsType="text"
                dropDownOptions={props.dataTypeList.map((d) => d.label)}
                position="left"
                unsetHeight={true}
                showOnScroll={true}
              />
            </div>
          </Show>
        </div>
        <div class={'pr-2'}>
          <TierLock
            targetFeature={TieringFeatures.SiteVis}
            options={{
              showBadge: true,
              disabledBehavior: TieringBehaviors.Restricted,
            }}
          >
            <modus-wc-tooltip
              content={props.tooltipAddItem}
              position="right"
              disabled={!props.tooltipAddItem}
            >
              <modus-button
                class="ms-2"
                color="secondary"
                button-style="borderless"
                icon-only="add"
                data-testid="project-data-manager-add-data-button"
                size="small"
                onClick={(e: CustomEvent): void => {
                  e.stopPropagation();
                  props.onAddItem(props.projectId);
                }}
                disabled={props.disableAddItem}
              >
                <modus-icon name="add" />
              </modus-button>
            </modus-wc-tooltip>
          </TierLock>
          <Show when={!hideForQ2}>
            <modus-button
              class="ms-2"
              color="secondary"
              button-style="borderless"
              icon-only="sort"
              size="small"
              onClick={(_e) => {
                onSort();
              }}
            />
            <modus-button
              class="ms-2"
              color="secondary"
              button-style="borderless"
              icon-only="search"
              size="small"
              onClick={(_e) => {
                onSearch();
              }}
            />
          </Show>
        </div>
      </div>
    </>
  );
};

export default DataHeader;
